import chroma from 'chroma-js';

export const CATEGORIES_THEME = {
    macros: chroma.brewer.PuBu,
    micros: chroma.brewer.BuPu,
    mesos: chroma.brewer.BuGn
};

export const generateShades = (category, count) => {
    return chroma.scale(CATEGORIES_THEME[category]).colors(count).map(color => chroma(color).darken().hex());
};

export const getMainColor = (category) => {
    return generateShades(category, 1);
}